<template>
  <AlgoliaSearchWrapper
  v-if="searchQuery != null"
  :indexName="algoliaIndex"
  :searchParameters="searchQuery"
  :hitsPerPage="20"
  >
    <v-row no-gutters>
      <v-col cols="4" class="mr-2" v-show="isFiltersVisible">
        <slot name="filters"></slot>
      </v-col>
      <v-col>
        <slot name="hits"></slot>
      </v-col>
    </v-row>
  </AlgoliaSearchWrapper>
</template>

<script>
import AlgoliaSearchWrapper from '@/components/general/AlgoliaSearchWrapper' // algolia dependencies
import { userOrganizationID } from '@/_services/amplify.service'
import { mapGetters } from 'vuex'
import moment from 'moment-timezone'
export default {
  name: 'AlgoliaInstanceBackLog',
  components: {
    AlgoliaSearchWrapper
  },
  props: {
    algoliaIndex: String,
    isFiltersVisible: { type: Boolean, default: false }
  },
  data () {
    return {
      searchQuery: null
    }
  },
  mounted () {
    userOrganizationID().then(({ organizationID }) => {
      let shipmentFilters = []
      // if (typeof this.$route.query.shipmentIDs === 'string') {
      //   shipmentFilters.push(`shipmentID:${this.$route.query.shipmentIDs}`)
      // } else {
      //   shipmentFilters = this.$route.query.shipmentIDs.map((id, index) => {
      //     if (index === 0) {
      //       return `shipmentID:${id}`
      //     }
      //     return `OR shipmentID:${id}`
      //   })
      // }
      // this.searchQuery = {
      //   filters: `viewable_by:${organizationID} AND (${shipmentFilters.join(' ')})`,
      //   hitsPerPage: 1000
      // }

      const departure = Number(this.$route.query.day)
      let start = moment.unix(departure).startOf('day').unix()
      let end = moment.unix(departure).endOf('day').unix()
      // let start = this.removeTimeStart(departure)
      // let end = this.removeTimeEnd(departure)
      this.searchQuery = {
        filters: `viewableBy:${organizationID} AND status: InTheBacklog`,
        // numericFilters: [`pickupLocal.from >= ${start}`, `pickupLocal.from <= ${end}`],
        numericFilters: [`departureUTC >= ${start}`, `departureUTC <= ${end}`],
        hitsPerPage: 20
      }
    })
  },
  methods: {
    initAlogliaSearchQuery (shipmentsArray) {
      userOrganizationID().then(({ organizationID }) => {
        // const shipmentFilters = shipmentsArray.map((id, index) => {
        //   if (index === 0) {
        //     return `shipmentID:${id}`
        //   }
        //   return `OR shipmentID:${id}`
        // })
        // this.searchQuery = {
        //   filters: `viewable_by:${organizationID} AND (${shipmentFilters.join(' ')})`,
        //   hitsPerPage: 1000
        // }
        let start = moment.unix(day).tz('Europe/Prague').set({
          hour: 0,
          minute: 0,
          second: 0,
          millisecond: 0
        }).unix()
        let end = moment.unix(day).tz('Europe/Prague').set({
          hour: 23,
          minute: 59,
          second: 59,
          millisecond: 999
        }).unix()
        this.searchQuery = {
          filters: `viewableBy:${organizationID}`,
          numericFilters: [`pickupLocal.from >= ${start}`, `pickupLocal.to <= ${end}`],
          hitsPerPage: 1000
        }
      })
    },
    removeTimeStart (startDate) {
      const userTimezone = moment.tz.guess()
      const localStartDate = moment.unix(startDate).tz(userTimezone).format()
      return moment(localStartDate).utc().set({
        hour: 0,
        minute: 0,
        second: 0,
        millisecond: 0
      }).unix()
      // return moment.unix(startDate).tz('UTC').set({
      //   hour: 0,
      //   minute: 0,
      //   second: 0,
      //   millisecond: 0
      // }).unix()
    },
    removeTimeEnd (endDate) {
      const userTimezone = moment.tz.guess()
      const localEndDate = moment.unix(endDate).tz(userTimezone).format()
      return moment(localEndDate).utc().set({
        hour: 23,
        minute: 59,
        second: 59,
        millisecond: 999
      }).unix()
      // return moment.unix(endDate).tz('UTC').set({
      //   hour: 23,
      //   minute: 59,
      //   second: 59,
      //   millisecond: 999
      // }).unix()
    }
  },
  computed: {
    ...mapGetters([
      'getPlannerShipments'
    ])
  },
  watch: {
    getPlannerShipments: {
      deep: true,
      immediate: true,
      handler (val, oldVal) {
        if (val.length > 0) {
          // this.initAlogliaSearchQuery(val.map(({ id }) => id))
        }
      }
    }
  }
}
</script>

<style>

</style>
